"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WatchProvidersAPI = void 0;
const base_1 = require("../base");
class WatchProvidersAPI extends base_1.BaseAPI {
    /**
     * Returns a list of all of the countries we have watch provider (OTT/streaming) data for.
     *
     * @see https://developers.themoviedb.org/3/watch-providers/get-available-regions
     */
    async availableRegions(filters) {
        const path = this.getPath('/watch/providers/regions', filters);
        return this.get(path);
    }
    /**
     * Returns a list of the watch provider (OTT/streaming) data we have available for movies. You can
     * specify a watch_region param if you want to further filter the list by country.
     *
     * @see https://developers.themoviedb.org/3/watch-providers/get-movie-providers
     */
    async movieProviders(filters) {
        const path = this.getPath('/watch/providers/movie', filters);
        return this.get(path);
    }
    /**
     * Returns a list of the watch provider (OTT/streaming) data we have available for TV series. You
     * can specify a watch_region param if you want to further filter the list by country.
     *
     * @see https://developers.themoviedb.org/3/watch-providers/get-tv-providers
     */
    async tvProviders(filters) {
        const path = this.getPath('/watch/providers/tv', filters);
        return this.get(path);
    }
}
exports.WatchProvidersAPI = WatchProvidersAPI;
